import { Illustrations } from 'Wpds/components/illustration';
const img = Illustrations.helping_hand_climbing_mountain_white_bg;

export const EmptyStateOptions = [
  {
    id: 'workspaceOpenNoneComplete',
    title: 'You don’t have any goals here yet.',
    subtitle: 'Create one now!',
    imgSrc: img,
    showCreateButton: true,
  },
  {
    id: 'workspaceOpenSomeComplete',
    title: 'You completed all your goals here!',
    subtitle: 'Way to go! Are you ready to create a new goal?',
    imgSrc: img,
    showCreateButton: true,
  },
  {
    id: 'workspaceComplete',
    title: 'You haven’t completed any goals here yet.',
    subtitle: 'Be the first one to get it done!',
    imgSrc: img,
    showCreateButton: false,
  },
  {
    id: 'teamOpenSomeCompleted',
    title: 'Your team completed all their goals!',
    subtitle: 'Way to go! Are you ready to create a new goal?',
    imgSrc: img,
    showCreateButton: true,
  },
  {
    id: 'teamOpenNoneCompleted',
    title: 'Your team doesn’t have any goals yet.',
    subtitle: 'Be the first one to create one!',
    imgSrc: img,
    showCreateButton: true,
  },
  {
    id: 'teamCompleted',
    title: 'Your team hasn’t completed any goals yet.',
    subtitle: 'Be the first one to get it done!',
    imgSrc: img,
    showCreateButton: false,
  },
];
